import React from 'react'
import {
    Drawer,
    ModalProps,
    DrawerBody,
    DrawerOverlay,
    DrawerHeader,
    DrawerContent,
    Spacer,
} from '@chakra-ui/react'
import { IconButton } from '@chakra-ui/react'
import { ChevronLeftIcon } from '@chakra-ui/icons'
import { useBreakpointValue } from '@chakra-ui/react'

import EmptyState from '~components/shared/empty-state'
import DetailedClientInfo from './detailed-client-info'
import { ClientFieldsFragment, ClientPortalAppFieldsFragment } from '~graphql/generated/graphql'
import AsyncWrapper from '~components/shared/wrappers/async-wrapper'
import OpenChatButton from '~components/shared/open-chat-button'
import SyncIndividualClientButton from '~components/shared/client/sync-from-pims-button'

interface Props extends Omit<ModalProps, 'children'> {
    client?: ClientFieldsFragment & ClientPortalAppFieldsFragment
    loading?: boolean
}

export default function ClientDetailsDrawer({
    client,
    loading,
    ...props
}: Props) {
    const modalSize = useBreakpointValue({ base: 'full', md: 'lg' })

    return (
        <Drawer
            placement="right"
            size={modalSize}
            blockScrollOnMount={false}
            {...props}
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader
                    pb={4}
                    shadow="blue.md"
                    display="flex"
                    justifyContent="space-between"
                    gap={3}
                >
                    <IconButton
                        size="sm"
                        icon={<ChevronLeftIcon fontSize="xl" />}
                        variant="outline"
                        rounded="full"
                        aria-label="Close Modal"
                        onClick={props.onClose}
                    />
                    <Spacer />
                    {client && (
                        <>
                            <OpenChatButton client={client} size="sm">
                                Open chat
                            </OpenChatButton>
                            <SyncIndividualClientButton client={client} />
                        </>
                    )}
                </DrawerHeader>
                <DrawerBody px={{ base: 2, md: 8 }} py={{ base: 4, md: 6 }}>
                    <AsyncWrapper
                        loading={loading}
                        empty={!client}
                        emptyComponent={<EmptyState title="Client Not Found" />}
                    >
                        <DetailedClientInfo client={client!} />
                    </AsyncWrapper>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}
